import { z } from 'zod';
import type { BaseEntity } from './common';
import type { Customer } from './customer';
import { IntegrationSystemEnum } from './integrationSystem';

/**
 * CustomerIntegration - Integrazione cliente
 * Rappresenta un'integrazione di un cliente con sistemi esterni
 * Corrisponde al modello backend CustomerIntegration
 */
export interface CustomerIntegration extends BaseEntity {
	/** ID del cliente sorgente */
	sourceId: number;
	/** Sistema di integrazione */
	system: IntegrationSystemEnum;
	/** Valore dell'integrazione nel sistema esterno (max 50 caratteri) */
	value: string;
	/** Cliente sorgente (navigation property, popolata con $expand=source) */
	source?: Customer;
}

/**
 * Schema Zod per la validazione runtime dei CustomerIntegration
 */
export const CustomerIntegrationSchema = z.object({
	id: z.number(),
	sourceId: z.number(),
	system: z.nativeEnum(IntegrationSystemEnum),
	value: z.string(),
	// Campi audit da BaseEntity
	createdAt: z.string(),
	modifiedAt: z.string().optional(),
	createdBy: z.string(),
	modifiedBy: z.string().optional(),
	// Navigation property opzionale (non validata in runtime)
	source: z.any().optional(),
});
